import { TableCell, TableFooter, TableRow, cn } from '@shigo-ui/ui';

import {
  type DashboardDataTableColumn,
  type DashboardDataTableFooterRow,
} from './DashboardDataTable.types';
import {
  isDashboardDataTableSelectionColumn,
  dashboardDataTableStickyCellClassName,
  dashboardDataTableStickyCellStyle,
} from './DashboardDataTableSticky';

export function DashboardDataTableTableFooter<TItem>({
  columns,
  footerRows,
}: {
  columns: DashboardDataTableColumn<TItem>[];
  footerRows: DashboardDataTableFooterRow<TItem>[];
}) {
  return (
    <TableFooter className="border-border bg-muted/30">
      {footerRows.map((footerRow) => (
        <TableRow
          key={footerRow.id}
          className={cn('border-border hover:bg-transparent', footerRow.className)}
        >
          {columns.map((column) => (
            <TableCell
              key={column.id}
              data-selection-column={isDashboardDataTableSelectionColumn(column.id) || undefined}
              className={cn(
                'px-2 py-2.5 text-[13px] font-semibold first:pl-4 last:pr-4',
                footerRow.cellClassName,
                dashboardDataTableStickyCellClassName(column),
              )}
              style={dashboardDataTableStickyCellStyle(column)}
            >
              {footerRow.cell(column)}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableFooter>
  );
}
